import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from 'src/app/ui/ui.module';

@Component({
  selector: 'app-subsidiary-change-confirmation-dialog',
  standalone: true,
  imports: [UiModule, NgIf, TranslateModule],
  templateUrl: './subsidiary-change-confirmation-dialog.component.html',
  styleUrls: ['./subsidiary-change-confirmation-dialog.component.scss']
})
export class SubsidiaryChangeConfirmationDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<SubsidiaryChangeConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { catalogType: 'agents' | 'catalogs' }
  ) {}

  goBack() {
    this.dialogRef.close(true)
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
